import React from 'react';
import styled, { keyframes } from 'styled-components/macro';
import PropTypes from 'prop-types';
import Section from 'components/Section';
import Container from 'components/Grid/Container';

const rotate = keyframes`
    from {
        transform: rotate(0deg);
    }

    to {
        transform: rotate(360deg);
    }
`;

const StyledSpinner = styled.div`
    margin: 0 auto;
    border-radius: 50%;
    width: 40px;
    height: 40px;
    position: relative;
    border: 3px solid rgba(111, 193, 62, 0.3);
    border-top-color: ${({ theme, $theme }) => theme.colors[$theme]};
    transform: translateZ(0);
    animation: ${rotate} 0.5s infinite linear;
`;

const Message = styled.p`
    text-align: center;
    margin-top: ${({ theme }) => theme.space.base};
`;

const Spinner = ({ showContainer, theme, message }) => {
    if (!showContainer) {
        return <StyledSpinner $theme={theme} />;
    }

    return (
        <Section minHeight="100vh">
            <Container>
                <StyledSpinner $theme={theme} />
                {message ? <Message>{message}</Message> : null}
            </Container>
        </Section>
    );
};

Spinner.defaultProps = {
    showContainer: true,
    theme: 'brand',
    message: null,
};

Spinner.propTypes = {
    showContainer: PropTypes.bool,
    theme: PropTypes.oneOf(['white', 'brand']),
    message: PropTypes.string,
};

export default Spinner;
